import EventBus from "@plugins/common/service/eventbus";
export const MediaPlayerEventBus = new EventBus();
